export const availableModels: {
  [modelKey: string]: { [modelYear: string]: string[] };
} = {
  'smart #1': {
    '2022': [
      'AMPLIFIER_FM2DAB',
      'ANTENNA_BLUETOOTH',
      'CHARGER_WIRELESS',
      'KEY ASSY',
      'MODULE_CEM',
      'MODULE_KEY COMMUNICATION_BLE AND NFC',
      'MODULE_TELEMATIC NODE',
      'MODULE_VEHICLE INFOTAINMENT',
      'RADAR_FORWARD MILLIMETER WAVE',
      'RADAR_SIDE OBSTACLE DETECTION',
      'SENSOR_TIRE PRESSURE',
      'BATTERY_HIGH VOLTAGE',
      'BATTERY_TELEMATIC NODE MODULE',
      'KEY ASSY + EUBR',
      'SENSOR_TIRE PRESSURE + EUBR',
      'SIREN_BACKUP BATTERY',
      'STORAGE BATTERY',
    ],
  },
  'smart #3': {
    '2023': [
      'AMPLIFIER_FM2DAB',
      'ANTENNA_BLUETOOTH',
      'CHARGER_WIRELESS',
      'KEY ASSY',
      'MODULE_CEM',
      'MODULE_KEY COMMUNICATION_BLE AND NFC',
      'MODULE_TELEMATIC NODE',
      'MODULE_VEHICLE INFOTAINMENT',
      'RADAR_FORWARD MILLIMETER WAVE',
      'RADAR_SIDE OBSTACLE DETECTION',
      'SENSOR_TIRE PRESSURE',
      'BATTERY_HIGH VOLTAGE',
      'BATTERY_TELEMATIC NODE MODULE',
      'KEY ASSY + EUBR',
      'SENSOR_TIRE PRESSURE + EUBR',
      'SIREN_BACKUP BATTERY',
      'STORAGE BATTERY',
    ],
  },
  'smart #5': {
    '2025': [
      'AMPLIFIER_FM2DAB + 2025',
      'ANTENNA-ULTRA WIDE BAND + 2025',
      'CHARGER_WIRELESS + 2025',
      'ECU MODULE-BLUETOOTH NFC COMMUNICATION + 2025',
      'KEY ASSY + 2025',
      'MODULE_TELEMATIC NODE + 2025',
      'MODULE_VEHICLE INFOTAINMENT + 2025',
      'NFCR_LATCH OPENER + 2025',
      'RADAR_FORWARD MILLIMETER WAVE + 2025',
      'RADAR_SIDE OBSTACLE DETECTION + 2025',
      'RADIO MODULE ASSY + 2025',
      'SENSOR_FOOT MOTION DETECTION_LOWER + 2025',
      'SENSOR_TIRE PRESSURE + 2025',
      'SENSOR-INTERIOR RADAR + 2025',
      'BATTERY_HIGH VOLTAGE + 2025',
      'BATTERY_TELEMATIC NODE MODULE + 2025',
      'KEY ASSY + 2025 + EUBR',
      'SENSOR_TIRE PRESSURE + 2025 + EUBR',
      'SIREN_BACKUP BATTERY + 2025',
      'STORAGE BATTERY + 2025',
    ],
  },
};
